/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum StatusType {
    LOGGED_ON_READY = 1,
    LOGGED_ON_NOT_READY = 2,
    LOGGED_OFF = 4,
}
